import { useContext, useMemo } from 'react';
import { FastSpringPaymentContext } from '../../context/FastSpringPaymentContext';
import MockupBlue from '../../images/mockup_niebieski.png';
import MockupGreen from '../../images/mockup_zielony.png';
import SzeryfDesktopImage from '../../images/szeryf-wstega_desktop.png';
import {
	FullPrice,
	ImageWrapper,
	Months,
	PlanWrapper,
	PromoPrice,
	SzeryfDesktop,
	TextInformationWrapper,
	Title,
} from './plan.styles';
import { LTL_CONFIG } from './constants/ltl.config';

const Plan = ({ promo, selectedOption }) => {
	const { ltl } = useContext(FastSpringPaymentContext);

	const displayData = useMemo(() => {
		const result = {
			title: LTL_CONFIG(ltl),
			months: `${selectedOption?.inAppPrice?.label}`,
			fullPrice: {
				pre: 'De',
				mid: selectedOption?.inAppPrice?.orginal_full_price,
				post: 'por',
			},
			promoPrice: `R$ ${selectedOption?.full_price} à vista`,
		};
		if (selectedOption?.type?.value === 'BASIC') {
			result.fullPrice = {};
		}

		if (promo) {
			result.fullPrice = {
				pre: 'De',
				mid: selectedOption?.inAppPrice?.orginal_full_price,
				post: 'por',
			};
			result.promoPrice = `R$ ${selectedOption?.promo_full_price} à vista`;
		}

		return result;
	}, [selectedOption, promo]);

	return (
		<PlanWrapper>
			<ImageWrapper>
				<img src={promo ? MockupGreen : MockupBlue} />
				<div>{displayData.months}</div>
			</ImageWrapper>
			<TextInformationWrapper>
				<Title>{displayData.title}</Title>
				<Months>({displayData.months})</Months>
				<FullPrice>
					{displayData?.fullPrice?.pre}{' '}
					<strong>
						<s>{displayData?.fullPrice?.mid}</s>
					</strong>{' '}
					{displayData?.fullPrice?.post}
				</FullPrice>
				<PromoPrice>{displayData.promoPrice?.replace('.', ',')}</PromoPrice>
			</TextInformationWrapper>
			<div style={{ flex: 1 }} />
			<SzeryfDesktop>
				<img src={SzeryfDesktopImage} />
			</SzeryfDesktop>
		</PlanWrapper>
	);
};

export default Plan;
